import { render, staticRenderFns } from "./DashboardComplain.vue?vue&type=template&id=d4b75ac2"
import script from "./DashboardComplain.vue?vue&type=script&lang=js"
export * from "./DashboardComplain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports